import { useEffect, useState } from 'react'

/**
 * Hook that returns true only after the next render cycle.
 * Useful for preventing MUI modal manager conflicts when opening nested dialogs.
 */
export const useNextRender = (): boolean => {
  const [canRender, setCanRender] = useState(false)

  useEffect(() => {
    // Force update on the next render cycle
    setCanRender(true)
  }, [])

  return canRender
}
